import { useState } from 'react';
import { CustomPopover, useCustomPopoverHook } from '@/components/popover/CustomPopover';
import { useLinkCategoryContextValueHook } from '../../../../../../contexts/LinkCategoryContextProvider';
import { ModuleCard } from '../weget-module-card/ModuleCard';
import * as St from './WegetSeparatorItem.styled';
import CustomBlockButton from '@/components/button/CustomBlockButton';
import { CustomRatioImage } from '@/components/image/CustomRatioImage';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';
import { customToast } from '@/components/toast/custom-react-toastify/v1';
import { CustomDialog } from '@/components/dialog/v1/CustomDialog';
import { CustomLabelTextarea } from '@/components/textarea/CustomLabelTextarea';
import CustomSelect from '@/components/select/default/v1/CustomSelect';
import { GlobalSeparatorVariables } from '@/variables/GlobalSeparatorVariables';

export function WegetSeparatorItem({
    moduleItemIndex,
    moduleItem,
    onReqDelete,
    onReqChangeIsHide,
    onReqUpdateInfo
}) {
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();
    const descriptionPopoverHook = useCustomPopoverHook();
    const thumbnailPopoverHook = useCustomPopoverHook();

    const [updateLinkItemModalOpen, setUpdateLinkItemModalOpen] = useState(false);

    const separatorConfig = moduleItem?.separatorConfig;
    const Separator = GlobalSeparatorVariables.list.find(r => r.separator === separatorConfig?.separator) || GlobalSeparatorVariables.list[0];

    const toggleUpdateLinkItemModalOpen = (bool) => {
        setUpdateLinkItemModalOpen(bool);
    }


    const handleSubmitUpdateLinkItem = (updateForm) => {
        updateForm = {
            id: moduleItem?.id,
            ...updateForm
        }

        onReqUpdateInfo(updateForm);
        toggleUpdateLinkItemModalOpen(false);
    }
    return (
        <>
            <ModuleCard
                id={moduleItem.id}
                index={moduleItemIndex}
                isHide={moduleItem?.isHide}
                badgeIcon='/assets/icons/separator_default_mainColor.svg'
                badgeLabel='구분선'
                categoryName={moduleItem?.linkCategoryId && linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.name}
                onEdit={() => toggleUpdateLinkItemModalOpen(true)}
                onToggleHide={onReqChangeIsHide}
                onDelete={onReqDelete}
            >
                <div>
                    <p className="text-[13px] font-semibold text-gray-700">{Separator?.name}</p>
                    <Separator.Component />
                </div>
            </ModuleCard>
            {descriptionPopoverHook?.anchorEl &&
                <CustomPopover
                    anchorEl={descriptionPopoverHook?.anchorEl}
                    onClose={() => descriptionPopoverHook?.closePopover()}
                    layoutStyle={!descriptionPopoverHook?.element ? { color: '#808080' } : {}}
                >
                    {descriptionPopoverHook?.element ? descriptionPopoverHook?.element : '등록된 설명이 없습니다.'}
                </CustomPopover>
            }

            {thumbnailPopoverHook?.anchorEl &&
                <CustomPopover
                    anchorEl={thumbnailPopoverHook?.anchorEl}
                    onClose={() => thumbnailPopoverHook?.closePopover()}
                    layoutStyle={!thumbnailPopoverHook?.element ? { color: '#808080' } : {}}
                >
                    {thumbnailPopoverHook?.element ?
                        (
                            <St.ThumbnailPopoverElement>
                                <CustomRatioImage>
                                    <CustomRatioImage.Image src={thumbnailPopoverHook?.element} />
                                </CustomRatioImage>
                            </St.ThumbnailPopoverElement>
                        )
                        :
                        '등록된 썸네일이 없습니다.'
                    }
                </CustomPopover>
            }

            {(updateLinkItemModalOpen && moduleItem) &&
                <UpdateModuleModal
                    open={updateLinkItemModalOpen}
                    moduleItem={moduleItem}
                    toggleOpenClose={toggleUpdateLinkItemModalOpen}
                    onConfirm={(body) => handleSubmitUpdateLinkItem(body)}
                />
            }
        </>
    );
}

function UpdateModuleModal({
    open,
    moduleItem,
    toggleOpenClose,
    onConfirm,
}) {
    const userPageContextValueHook = useUserPageContextValueHook();
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();

    const separatorConfig = moduleItem?.separatorConfig;

    const [separatorViewMode, setSeparatorViewMode] = useState('DEFAULT'); // DEFAULT, EDIT
    const [separatorType, setSeparatorType] = useState(separatorConfig?.separator);

    const [linkCategoryId, setLinkCategoryId] = useState(linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.id || '');

    const CurrentSeparator = GlobalSeparatorVariables.list.find(r => r.separator === separatorType);

    const handleChangeSeparatorViewMode = (mode) => {
        setSeparatorViewMode(mode);
    }

    const handleChangeLinkCategoryId = (e) => {
        const value = e.target.value;

        setLinkCategoryId(value || '');
    }

    const handleChangeSeparatorType = (type) => {
        setSeparatorType(type);
        handleChangeSeparatorViewMode('DEFAULT');
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let body = {
            ...moduleItem,
            type: 'SEPARATOR',
            linkCategoryId: linkCategoryContextValueHook?.content?.find(r => r?.id === linkCategoryId)?.id || '',
            userPageId: userPageContextValueHook?.userPage?.id,
            separatorConfig: {
                separator: separatorType,
                iconColorHex: '#808080'
            }
        }
        onConfirm(body);
    }

    return (
        <>
            <CustomDialog open={open} onClose={() => toggleOpenClose(false)} maxWidth='sm'>
                {(!separatorViewMode || separatorViewMode === 'DEFAULT') &&
                    <St.UpdateModuleContainer>
                        <CustomDialog.Header style={{ marginBottom: '20px' }}>
                            <CustomDialog.Header.Fake />
                            <CustomDialog.Header.Title>구분선 모듈</CustomDialog.Header.Title>
                            <CustomDialog.Header.Close onClick={() => toggleOpenClose(false)} />
                        </CustomDialog.Header>
                        <div className='wrapper default'>
                            <div className='itemWrapper'>
                                <label><span style={{ color: 'var(--redColor1)' }}>*</span> 구분선</label>
                                <div className='itemBox' onClick={() => handleChangeSeparatorViewMode('EDIT')}>
                                    <section className='content'>
                                        <div className='name'>{CurrentSeparator.name}</div>
                                        <CurrentSeparator.Component />
                                    </section>
                                    <section className='go'>
                                        <figure className='icon'>
                                            <CustomRatioImage>
                                                <CustomRatioImage.Image src={'/assets/icons/arrowForward_default_000000.svg'} alt={'arrow forward'} />
                                            </CustomRatioImage>
                                        </figure>
                                    </section>
                                </div>
                            </div>
                            <div className='wrapper__selectBox'>
                                <CustomSelect
                                    value={linkCategoryId}
                                    onChange={(e) => handleChangeLinkCategoryId(e)}
                                >
                                    <option value=''>전체</option>
                                    {linkCategoryContextValueHook?.content?.map(linkCategory => {
                                        return (
                                            <option key={linkCategory?.id} value={linkCategory?.id}>{linkCategory?.name}</option>
                                        );
                                    })}
                                </CustomSelect>
                                <label>카테고리{linkCategoryId && <span style={{ color: 'var(--redColor1)', paddingLeft: '10px' }}>* 카테고리가 선택 되었어요!</span>}</label>
                            </div>
                            <div className='wrapper__footerButtonGroup'>
                                <CustomBlockButton
                                    type='button'
                                    onClick={(e) => handleSubmit(e)}
                                >
                                    수정
                                </CustomBlockButton>
                            </div>
                        </div>
                    </St.UpdateModuleContainer>
                }

                {(separatorViewMode === 'EDIT') &&
                    <St.UpdateModuleContainer>
                        <CustomDialog.Header style={{ marginBottom: '20px' }}>
                            <CustomDialog.Header.Back onClick={() => handleChangeSeparatorViewMode('DEFAULT')} />
                            <CustomDialog.Header.Title>구분선 선택</CustomDialog.Header.Title>
                            <CustomDialog.Header.Close onClick={() => toggleOpenClose(false)} />
                        </CustomDialog.Header>
                        <div className='wrapper edit'>
                            <div className='body'>
                                <div className='itemList'>
                                    {GlobalSeparatorVariables.list.map(Separator => {
                                        return (
                                            <div
                                                key={Separator.separator}
                                                className='itemBox'
                                                onClick={() => handleChangeSeparatorType(Separator.separator)}
                                            >
                                                <section className='content'>
                                                    <div className='name'>{Separator.name}</div>
                                                    <Separator.Component />
                                                </section>
                                                <section className='go'>
                                                    <figure className='icon'>
                                                        <CustomRatioImage>
                                                            <CustomRatioImage.Image src={'/assets/icons/arrowForward_default_000000.svg'} alt={'arrow forward'} />
                                                        </CustomRatioImage>
                                                    </figure>
                                                </section>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </St.UpdateModuleContainer>
                }
            </CustomDialog>
        </>
    )
}